export { default } from './isImmutableSeq'
